import { toggleMark } from 'prosemirror-commands'
import { MarkType } from 'prosemirror-model'
import { type EditorView } from 'prosemirror-view'

import { preserveSelection } from 'common/Prose/utils'
import { HIDDEN_INPUT_ID } from 'screens/ProseEdit/Constants'

export const timedOutToggleMark = (type: MarkType, view: EditorView) => () => {
  // Move the focus to another input to keep the keyboard up
  document.getElementById(HIDDEN_INPUT_ID)?.focus()
  // the timeout is necessary for certain browsers (safari) not to eat the
  // selection anyways
  setTimeout(() => {
    const {
      state: { tr },
    } = view
    const command = toggleMark(type)

    command(view.state, view.dispatch)
    preserveSelection(tr, view.state)
    view.focus()
  })
}
